import React from "react";
import FaqIntro from "./FaqIntro";
import FaqStudent from "./FaqStudent";
import FaqCounsellor from "./FaqCounsellor";
import FaqCommon from "./FaqCommon";


export default function FaqFooter() {
    return (
        <div>
            <FaqIntro />
            <FaqCommon />
            <FaqStudent />
            <FaqCounsellor />
        </div>
    )
}